import { render } from "./ProfilePreferences.vue?vue&type=template&id=04e992da&scoped=true&ts=true"
import script from "./ProfilePreferences.vue?vue&type=script&lang=ts"
export * from "./ProfilePreferences.vue?vue&type=script&lang=ts"

import "./ProfilePreferences.vue?vue&type=style&index=0&id=04e992da&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e992da"]])

export default __exports__